import DateTime from 'utils/datetime';
import i18n from 'utils/i18n';

const { t } = i18n.i18n;

export const getMonths = (from: string, to: string) => {
  const dayjsFrom = DateTime.toDayjs(from);
  const dayjsTo = DateTime.toDayjs(to);
  const totalMonths = DateTime.diff(to, from, 'month') + 1; // include last month

  const res: { start: string; end: string }[] = [];

  for (let i = 0; i < totalMonths; i++) {
    let currentStart = DateTime.now(),
      currentEnd = DateTime.now();
    const isFirstMonth = i === 0;
    const isLastMonth = i === totalMonths - 1;

    if (isFirstMonth) {
      // If it's the first month, adjust the start to the beginning of the month
      currentStart = dayjsFrom;
      currentEnd = DateTime.endOfMonth(dayjsFrom);
    }
    if (isLastMonth) {
      // If it's the last month, adjust the end to the to date
      currentStart = DateTime.startOfMonth(dayjsTo);
      currentEnd = dayjsTo;
    }

    if (!isFirstMonth && !isLastMonth) {
      // For all other months, use the start and end of the month
      currentStart = DateTime.startOfMonth(DateTime.add(dayjsFrom, i, 'month'));
      currentEnd = DateTime.endOfMonth(DateTime.add(dayjsFrom, i, 'month'));
    }

    res.push({
      start: currentStart.toString(),
      end: currentEnd.toString(),
    });
  }

  return res.length
    ? res
    : [
        {
          start: DateTime.toDayjs(from).toString(),
          end: DateTime.endOfMonth(from).toString(),
        },
      ];
};

export const isCurrentMonth = (fromDate: string, toDate: string) =>
  DateTime.isSameOrAfter(DateTime.now(), fromDate, 'day') &&
  DateTime.isSameOrBefore(DateTime.now(), toDate, 'day');

export const isPastMonth = (fromDate: string, toDate: string) =>
  DateTime.isAfter(DateTime.now(), toDate, 'day');

export const isFutureMonth = (fromDate: string, toDate: string) =>
  DateTime.isBefore(DateTime.now(), fromDate, 'day');

export const getMonthType = (
  fromDate: string,
  toDate: string,
): 'past' | 'present' | 'future' => {
  if (isPastMonth(fromDate, toDate)) return 'past';
  if (isCurrentMonth(fromDate, toDate)) return 'present';
  if (isFutureMonth(fromDate, toDate)) return 'future';
  return 'future'; // fallback
};

export const getMonthDescription = (type: 'past' | 'present' | 'future') => {
  const map = {
    past: t('seasonOverview.widgets.seasonProgress.pastMonth'), // 'Past',
    present: t('seasonOverview.widgets.seasonProgress.currentMonth'), // 'Current',
    future: t('seasonOverview.widgets.seasonProgress.futureMonth'), // 'Not Started',
  };

  return map[type] || '';
};
